import magic from "../../../images/icons/magic.svg"
import success from "../../../images/success.svg"

export const formTypes = {
  EmailForm: {
    headerTxt: "Login or Create an Account",
    btns: [
      {
        txt: "Cancel",
        customClass: "clear-btn",
        customEvent: "onClose",
      },
      {
        txt: "Continue",
        customClass: "blue-btn",
        customEvent: "onSubmit"
      },
    ],
    isRow: false,
  },
  WelcomeBackForm: {
    headerTxt: "Welcome Back!",
    btns: [
      {
        txt: "Login",
        customClass: "blue-btn",
        customEvent: "onSubmit",
        orLine: true
      },
      {
        txt: "Sign in with Magic Link",
        customClass: "white-btn magic-link",
        customEvent: "sendMagicLink"
      },
    ],
    isRow: true,
  },
  AgentInfo: {
    headerTxt: "Enter your Agent Info!",
    btns: [
      {
        txt: "Find My Agent",
        customClass: "blue-btn",
        customEvent: "onSubmit",
        orLine: true
      },
      {
        txt: "Use this Agents information to Create an Account",
        createAccount: true,
        customClass: "white-btn mb-4",
        customEvent: "onUseListingAgent"
      },
      {
        txt: "Find a REALTORⓇ on Mibor.com",
        customClass: "button-custom white-btn",
        link: "https://member.mibor.com/en-us/Directories/Find-a-Realtor"
      },
      {
        txt: "or Click here to Search without logging in",
        link: "/search/public/",
        customClass: "agent-info-link margin-btn",
        customEvent: "linkSearchPublic"
      }
    ],
    isRow: true,
    alertTxt: false,
  },
  AgentFound: {
    headerTxt: "Contact Agent",
    btns: [
      {
        txt: "Back",
        customClass: "white-btn self-align",
        customEvent: "backToFind"
      },
      {
        txt: "Cancel",
        customClass: "clear-btn",
        customEvent: "onClose"
      },
      {
        txt: "Create Account",
        customClass: "blue-btn",
        customEvent: "onSubmit"
      }
    ],
  },
  AccountPending: {
    isMessage: true,
    headerTxt: "Account Pending",
    text: "Your request for an account has already been submitted to an Agent. We will notify you when your account has been created.",
    btns: [
      {
        txt: "Click here to Search without logging in",
        link: "/search/public/",
        customClass: "white-btn button-custom border-0",
        customEvent: "linkSearchPublic"
      }
    ],
    isRow: true,
  },
  CheckInbox: {
    isMessage: true,
    headerTxt: "Check your inbox",
    text: "We sent a Magic Link to your email. The link expires in 2 hours, so be sure to use it soon",
    icon: magic
  },
  LinkActivated: {
    isMessage: true,
    headerTxt: "Magic Link Activated",
    text: "You have successfully logged in using a Magic Link.",
    icon: success
  },
  SucessCreated: {
    isMessage: true,
    headerTxt: "Account Successfully Submitted",
    text: "Your account has been submitted to the Agent and you will receive an email shortly when your account is activated",
    icon: success
  }
}